module.exports = __webpack_public_path__ + "static/bee.a69f8dcf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/schools/bee.jpg
// module id = 133
// module chunks = 29745001925707 82267189633957